import { useEffect, useRef, useState } from "react"

import {
  ensureDocumentSubClassGroups,
  loadStoredConfig,
  saveStoredConfig,
  type SummarizerConfig,
} from "@/utils/summarizer-config"

export function useSummarizerConfig(storageKey: string, classificationNames: string[]) {
  const migrationPending = useRef(false)
  const [config, setConfig] = useState<SummarizerConfig>(() => {
    const stored = loadStoredConfig(storageKey)
    const normalized = ensureDocumentSubClassGroups(stored, classificationNames)
    migrationPending.current = normalized !== stored
    return normalized
  })
  const [saveError, setSaveError] = useState(false)
  const latest = useRef(config)

  useEffect(() => {
    if (migrationPending.current) {
      migrationPending.current = false
      setSaveError(!saveStoredConfig(storageKey, latest.current))
    }
  }, [storageKey])

  function update(updater: (current: SummarizerConfig) => SummarizerConfig) {
    const next = updater(latest.current)

    latest.current = next
    setConfig(next)
    setSaveError(!saveStoredConfig(storageKey, next))
  }

  return { config, update, saveError }
}
